import { Layout } from "layout"
import { Outlet } from "react-router"

const Panel = () => (
  <Layout>
    <Outlet />
  </Layout>
)

export default Panel
